/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Client from 'fierry/flux/entity/client';

import Command from 'shared/alias/command';
import Layout from 'shared/client/layout/state';
import Navigation from 'shared/client/navigation';
import Url from 'shared/client/url';
import Behavior from 'shared/client/behavior';

import * as Array from 'fierry/util/array';


export default new Client ([ Command, Layout, Url, Navigation, Behavior ], class
{
  constructor (command, layout, url, navigation, behavior)
  {
    this.command = command;
    this.layout = layout;
    this.url = url;
    this.navigation = navigation;
    this.behavior = behavior
  }


  onDone ()
  {
    if (this.command && this.command.onDone)
    {
      this.command.onDone();
    }

    this.onCancel();
  }


  onCancel ()
  {
    if (this.command && this.command.onCancel)
    {
      this.command.onCancel()
    }

    this.url.popForeground();
  }


  // future.entity
  getType ()
  {
    return this.url.getRoute().getValue();
  }


  // future.entity
  getArgs ()
  {
    return this.url.getRoute().getArgs();
  }


  getError ()
  {
    if (this.command && this.command.getError)
    {
      return this.command.getError();
    }

    return null;
  }


  getInfo ()
  {
    if (this.command && this.command.getInfo)
    {
      return this.command.getInfo();
    }

    return null;
  }


  getInitial ()
  {
    if (this.command && this.command.getInitial)
    {
      return this.command.getInitial();
    }

    return null;
  }


  isError ()
  {
    return this.getError() !== null;
  }


  isInitial ()
  {
    return this.getInitial() !== null;
  }


  isInvalid ()
  {
    return this.isInitial() || this.isError();
  }


});
